import { AfterViewInit, Directive, ViewContainerRef } from '@angular/core';
import { FiContenteditableSimpleTextPanelRootDirective } from './fi-contenteditable-simple-text-panel-root.directive';

@Directive({
    selector: '[fi-contenteditable-simple-text-panel-root-ref]',
    standalone: false,
})
export class FiContenteditableSimpleTextPanelRootRefComponent implements AfterViewInit {
    constructor(
        public contenteditableSimpleTextPanelRootDirective: FiContenteditableSimpleTextPanelRootDirective,
        public viewContainerRef: ViewContainerRef,
    ) {}

    ngAfterViewInit() {
        this.contenteditableSimpleTextPanelRootDirective.setCurrentViewContainerRef(this.viewContainerRef);
    }
}
